/**
 * GlassCard — Layer-1 minimal card wrapper.
 * No glassmorphism, no gradient borders. Clean paper surface with subtle shadow.
 * @layer-1 — propagate to all features automatically.
 */
import { Card } from "@/components/ui/card";
import { cn } from "@/shared/lib/utils";

interface GlassCardProps {
  className?: string;
  children: React.ReactNode;
  padding?: "sm" | "md" | "lg";
}

const paddingMap = {
  sm: "p-6",
  md: "p-8",
  lg: "p-10 md:p-12",
} as const;

export function GlassCard({
  className,
  children,
  padding = "lg",
}: GlassCardProps) {
  return (
    <Card
      className={cn(
        "rounded-2xl",
        // Clean paper surface, subtle warm shadow. Surface + border come from
        // dark-aware tokens so the card flips with the color mode (light keeps
        // pure-white paper; dark uses the elevated card surface).
        "bg-white dark:bg-[var(--surface-card)] border-[var(--border-light)] shadow-[0_4px_24px_rgba(20,20,19,0.06)]",
        paddingMap[padding],
        className
      )}
    >
      {children}
    </Card>
  );
}
